import React, { useState } from "react";
import "./LudoBetModal.css";
import { calculateLudoWinning } from "./ludoPrize.js";

function LudoBetModal({
    mode,
    onClose,
    onConfirm,
    loading,
    playSound,
    wallet = 0,
    onHistory,
    onRules,
    historyLoading = false,
}) {
    const [amount, setAmount] = useState(100);

    const amounts = [10, 50, 100, 500, 1000, 5000];

    const playerCount =
        mode === "2-player" ? 2 :
        mode === "3-player" ? 3 : 4;

    const winningPrize = amount * playerCount;
    const { netWinning } = calculateLudoWinning(winningPrize);

    return (
        <div className="ludo-bet-overlay">
            <div className="ludo-bet-modal">
                <button className="ludo-bet-close" onClick={onClose} disabled={loading}>×</button>

                <div className="bet-dice-icon">🎲</div>
                <h2>{playerCount} Players</h2>
                <p className="bet-subtitle">Choose your entry amount</p>

                <div className="ludo-wallet-box">
                    <span>💰 WALLET BALANCE</span>
                    <strong>₹{Number(wallet).toLocaleString()}</strong>
                </div>

                <div className="bet-amount-grid">
                    {amounts.map((value) => (
                        <button
                            key={value}
                            type="button"
                            className={amount === value ? "selected" : ""}
                            onClick={() => {
                                playSound("click");
                                setAmount(value);
                            }}
                        >
                            ₹{value}
                        </button>
                    ))}
                </div>

                <div className="custom-bet">
                    <span>₹</span>
                    <input
                        type="number"
                        min="1"
                        value={amount}
                        onChange={(e) => setAmount(Number(e.target.value))}
                    />
                </div>

                <div className="ludo-bet-preview">
                    <div>
                        <span>YOUR BET</span>
                        <strong>₹{Number(amount).toLocaleString()}</strong>
                    </div>
                    <div>
                        <span>POTENTIAL WIN</span>
                        <strong>₹{Number(netWinning).toLocaleString()}</strong>
                    </div>
                </div>

                <div className="ludo-info-buttons">
                    <button
                        type="button"
                        onClick={() => {
                            playSound("click");
                            onRules?.();
                        }}
                    >
                        📖 <span>RULES</span>
                    </button>

                    <button
                        type="button"
                        onClick={() => {
                            playSound("click");
                            onHistory?.();
                        }}
                        disabled={historyLoading}
                    >
                        📜 <span>{historyLoading ? "LOADING..." : "HISTORY"}</span>
                    </button>
                </div>

                <button
                    className="place-bet-btn"
                    disabled={
                        loading ||
                        !amount ||
                        amount <= 0 ||
                        Number(amount) > Number(wallet)
                    }
                    onClick={() => {
                        playSound("click");
                        onConfirm(amount);
                    }}
                >
                    {loading ? "Placing Bet..." : `Play ₹${Number(amount).toLocaleString()}`}
                </button>

                {Number(amount) > Number(wallet) && (
                    <div className="insufficient-wallet">
                        Insufficient wallet balance
                    </div>
                )}

                <small>Players will join automatically</small>
            </div>
        </div>
    );
}

export default LudoBetModal;
